import { DenialResponse } from '../../models/manageWarehouse/denial-response.model';
import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globals } from '../../shared/globals/globals';
import { DenialRequest } from '../../models/manageWarehouse/denial-request.model';

@Injectable({
	providedIn: 'root'
})
export class DenialService {

	httpOptions = {
		headers: new HttpHeaders({
			'Content-type': 'application/json'
		}),
		params: new HttpParams()
	};

	private subRoute = "/api/v1/denail/"

	constructor(
		private http: HttpClient,
		private globals: Globals
	) {
		this.http = http;
		this.globals = globals;
	}

	getDenialLabel(denial: number): Observable<DenialResponse> {
		this.httpOptions.params = this.httpOptions.params.delete("denialUidK");
		this.httpOptions.params = this.httpOptions.params.delete("subDivisionUidD");
		this.httpOptions.params = this.httpOptions.params.delete("bkWarehouseUidD");
		this.httpOptions.params = this.httpOptions.params.append("denialUidK", denial);
		this.httpOptions.params = this.httpOptions.params.append("subDivisionUidD", this.globals.user.warehouse.bkSubDivisionUidD); //CLOSED - 4
		this.httpOptions.params = this.httpOptions.params.append("bkWarehouseUidD", this.globals.user.warehouse.warehouseUidK); // CLOSED - 13

		const URL = environment.backend_url + this.subRoute + "search"

		return this.http.get<DenialResponse>(URL, this.httpOptions);

	}

	saveDenialLabel(request: DenialRequest): Observable<any> {
		const URL = environment.backend_url + this.subRoute + "closeDenial";

		return this.http.post<any>(URL, request, this.httpOptions);
	}
}
